import React, { useEffect, useMemo, useRef, useState } from 'react';
import { checkAuthenticated, IAuthentication, initialAuthentication } from './authentication';
import AuthenticationContext from './authentication.context';

const supportedRoles: string[] = ['verantwoordelijke', 'beheerder'];
const extractSupportedRoles = (roles: string[]) => roles.filter((role) => supportedRoles.includes(role.toLowerCase()));

const SecuredApp: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [authentication, setAuthentication] = useState(initialAuthentication);

  const keycloakInitializationStarted = useRef(false);

  useEffect(() => {
    if (!keycloakInitializationStarted.current) {
      keycloakInitializationStarted.current = true;
      (async () => {
        setAuthentication((prevState: IAuthentication) => ({
          ...prevState,
          busyAuthenticating: true,
        }));
        try {
          const auth = await checkAuthenticated();
          const supportedRoles = extractSupportedRoles(auth.rollen ?? []);
          if (!auth.authenticated || supportedRoles.length === 0) {
            setAuthentication({
              ...auth,
              rollen: [],
              authorised: false,
            });
          } else {
            setAuthentication({
              ...auth,
              rollen: supportedRoles,
              busyAuthenticating: false,
            });
          }
        } catch {
          setAuthentication({
            ...initialAuthentication,
            busyAuthenticating: false,
          });
        }
      })();
    }
  }, []);

  const providerValue = useMemo(() => authentication, [authentication]);

  return <AuthenticationContext.Provider value={providerValue}>{children}</AuthenticationContext.Provider>;
};

export default SecuredApp;
